import { render, staticRenderFns } from "./VersionUpdate.vue?vue&type=template&id=59f33ef2&scoped=true&"
import script from "./VersionUpdate.vue?vue&type=script&lang=js&"
export * from "./VersionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./VersionUpdate.vue?vue&type=style&index=0&id=59f33ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f33ef2",
  null
  
)

export default component.exports